import React from 'react';
import * as PropTypes from 'prop-types';
import { LinkIcon, ArrowLongRightIcon, DevicePhoneMobileIcon } from '@heroicons/react/24/outline';

const SMSFeatureNotice = ({ title, description, children }) => {
  return (
    <div className="flex flex-col items-center p-4">
      <div className="flex flex-row mb-7">
        <LinkIcon className="h-8 w-8" />
        <ArrowLongRightIcon className="h-8 w-8 text-teal-400 ml-2" />
        <DevicePhoneMobileIcon className="h-8 w-8 ml-2" />
      </div>
      <div className="text-center text-slate-700 mb-4 text-lg">
        <p className="font-semibold">{title}</p>
        <p>{description}</p>
      </div>
      {children}
    </div>
  );
};

SMSFeatureNotice.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default SMSFeatureNotice;
